import { Amplify } from 'aws-amplify';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { loadConfig } from './aws-exports';
import reportWebVitals from './reportWebVitals';
import { smokeChatApi, getMessages, postMessage } from './utils/chatClient';
import './index.css';

// Configure Amplify with runtime config
loadConfig().then((config) => {
  Amplify.configure(config);

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // Expose chat helpers for console-based local verification
  window.smokeChatApi = smokeChatApi;
  window.getMessages = getMessages;
  window.postMessage = postMessage;
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
